import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { AssignRole, Pages, Roles, } from './sub-pages';

const RolesManagement = () => {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <>
      <Nav tabs>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '1' ? 'active' : ''}`} onClick={() => setActiveTab('1')}>Pages</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '2' ? 'active' : ''}`} onClick={() => setActiveTab('2')}>Roles</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '3' ? 'active' : ''}`} onClick={() => setActiveTab('3')}>Assign Roles</NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab} className="border border-top-0 p-3 mt-2 bg-white">
        <TabPane tabId="1"><Pages /></TabPane>
        <TabPane tabId="2"><Roles /></TabPane>
        <TabPane tabId="3"><AssignRole /></TabPane>
      </TabContent>
    </>
  );
};

export default RolesManagement;
